import { io, Socket } from 'socket.io-client';

// Re-export io so callers don't need to import socket.io-client directly
export { io };

let _socket: Socket | null = null;

export function getSocket(): Socket | null {
  return _socket;
}

export function setSocket(s: Socket) {
  _socket = s;
}
